import { useNetworkState } from '@leanpay/hooks'

import { ErrorIcon } from '../../assets/icons/error-icon'

export const OfflineIndicator = () => {
    const network = useNetworkState()

    if (network.online === false)
        return (
            <div className="absolute top-4 flex w-full justify-center text-center z-[1000]">
                <div className="flex rounded-md items-center bg-lp-error gap-1 py-1 px-1 shadow-md">
                    <ErrorIcon />
                    <p className="text-lg font-semibold">Network Offline</p>
                </div>
            </div>
        )

    return null
}
